import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';
import { Location } from 'history';

interface LocationInfo {
    location: Location
    admin: boolean
}


export const useLocationInfo: () => LocationInfo = () => {
    const location: Location = useLocation();

    return {
        location,
        admin: location.pathname.startsWith('/admin/')
    }
}